import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeCartItem, updateCartItem } from "../redux/cartSlice";
import { addToWishlist } from "../../../../components/Wishlist/WishlistSlice";
import { useCartWishlist } from "../../../../app/CartWishlistContext";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

export const useCartActions = () => {
    const dispatch = useDispatch();
    const { getCartWishlistCount } = useCartWishlist();
    const { pinset } = useSelector((state) => state.pincode);
    const [updatingId, setUpdatingId] = useState(null);

    const handleRemoveItem = async (cartId) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to remove this item from Cart!",
            showCancelButton: true,
        });

        if (!result.isConfirmed) return;

        try {
            await dispatch(removeCartItem(cartId)).unwrap();
            getCartWishlistCount();
        } catch {
            toast.error("Failed to remove item");
        }
    };

    const handleUpdateQty = async (product_id, newQty) => {
        if (newQty < 1) return;

        setUpdatingId(product_id);
        try {
            await dispatch(
                updateCartItem({ product_id, quantity: newQty })
            ).unwrap();
        } catch {
            toast.error("Failed to update quantity");
        } finally {
            setUpdatingId(null);
        }
    };

    const handleMoveToWishlist = async (item) => {
        await dispatch(addToWishlist({ product_id: item.product.id }));
        await dispatch(removeCartItem(item.id));
        toast.success("Product added to Wishlist");
        setTimeout(getCartWishlistCount, 800);
    };

    return {
        updatingId,
        handleRemoveItem,
        handleUpdateQty,
        handleMoveToWishlist,
        pinset,
    };
};